
export class RegExpUtils {
    /** 用户邮箱正则 */
    public static readonly REGEXP_USER_EMAIL: RegExp = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

    /** 用户密码正则 */
    public static readonly REGEXP_USER_PASSWORD: RegExp = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[`~!=|<>/@_#$%^&*\(\)\-\\\[\]\{\}\+\.\?\,\;\:\"\'])(?!.*\s).{8,20}$/;
    /** 用户名正则 **/
    public static readonly REGEXP_USER_NAME: RegExp = /^.{1,36}$/;

    // 文件名称正则
    public static readonly REGEXP_FILE_NAME: RegExp = /^[^\\\/:*?\"<>|]+$/;

    // 联系电话正则
    public static readonly REGEXP_CONTACT: RegExp = /(^[\+]?((\([\d]+\))|([\d\-])|([\d\s]))*[\d]+)/;

    // 店铺Url地址正则
    public static readonly REGEXP_STOR_EUrl: RegExp = /https\:\/\/[\w\-\.]*(:[\d]+)?(\/[\w\-\.]+\s*)*/;

    // Etsy店铺产品标题正则
    public static getEtsyProductTitleReg(): RegExp {
        const rewritePattern = require("regexpu-core");
        // rewritePattern会将'\'去除一次，所以需要使用\\
        const pattern = rewritePattern('^(?!.*([%:&+]).*\\1)[\\p{L}\\p{Nd}\\p{P}\\p{Sm}\\p{Zs}™©®]+$', 'u', {
            unicodeFlag: 'transform'
        });
        return pattern;
    }

    public static validateEtsyProductTitle(val: string): boolean {
        const pattern = RegExpUtils.getEtsyProductTitleReg();
        return pattern.test(val);
    }

    public static validateEmail(val: string): boolean {
        return this.REGEXP_USER_EMAIL.test(val);
    }

    public static validatePassword(val: string): boolean {
        return this.REGEXP_USER_PASSWORD.test(val);
    }

    public static validateFileName(val: string) {
        return this.REGEXP_FILE_NAME.test(val);
    }

    public static validateContact(val: string): boolean {
        return this.REGEXP_CONTACT.test(val);
    }
}